import AnalyticsTracker from './analytics_tracker'
import env from '@polleverywhere/core/lib/env'
import Backbone from '@polleverywhere/backbone'

function log (prefix = 'DEBUG', message, ...args) {
  if (prefix == null) {
    prefix = 'DEBUG'
  }

  let opts = []

  if (typeof message === 'string') {
    opts.push(`[${prefix}] ${message}`)
  } else {
    opts.push(`[${prefix}]`)
    opts.push(message)
  }

  opts = opts.concat(args)
  console.info.apply(console, opts)
}

/**
 * Show debugging info
 */
export default (app) => {
  window.app = app

  log(null, 'App is available at `window.app`')
  log(null, 'App options', app.options)
  log(null, 'App env', env.attributes)

  const dispatcher = _.clone(Backbone.Events)
  dispatcher.listenTo(app, 'reset:state', (state) => {
    log(null, 'Session started')

    if (app.options.router) {
      log(null, 'URL Routes:', Backbone.history.handlers.map((h) => h.route))
    }
  })

  AnalyticsTracker(app).on('change', (model) => {
    log('AnalyticsTracker', model.attributes, 'changed:', model.changedAttributes())
  })
}
